<template lang="pug">
modal-window.modal-study-confirm.align-center(:width='500', :height='350', ref='modal')
  .modal-study-confirm__inner
    .modal-study-confirm__inner__title.text-xlarge
      slot(name='studyConfirmTitle')
    .modal-study-confirm__inner__body.text-large
      //- 未入力アラート
      .modal-study-confirm__inner__body__alart(v-if='notAnsweredNumbers')
        .modal-study-confirm__inner__body__alart__text.text-small(v-for='notAnsweredNumber in notAnsweredNumbers')
          .modal-study-confirm__inner__body__alart__text__value {{ notAnsweredNumber }}
          .modal-study-confirm__inner__body__alart__text__label
            slot(name='notAnsweredLabel')
      .modal-study-confirm__inner__body__text
        slot(name='studyConfirmText1')
      .modal-study-confirm__inner__body__text
        slot(name='studyConfirmText2')
    .modal-study-confirm__inner__footer
      button-primary.modal-study-confirm__inner__footer__button(@click='submitEvent')
        slot(name='submitText')
      button-primary.modal-study-confirm__inner__footer__button(@click='hide')
        slot(name='hideText')
</template>

<script lang="ts">
import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import ModalWindow from '@/components/molecules/student/ModalWindow.vue'
import ButtonPrimary from '@/components/molecules/student/ButtonPrimary.vue'

/**
 * 学習画面確認モーダル
 */
@Component({
  components: {
    ModalWindow,
    ButtonPrimary,
  },
})
export default class ModalStudyConfirm extends Vue {
  // 未入力問題番号
  @Prop()
  notAnsweredNumbers?: string[]

  // OKボタン押下時イベント
  @Prop()
  submitEvent!: Function

  @Ref() modal!: ModalWindow

  public show() {
    this.modal.show()
  }

  public hide() {
    this.modal.hide()
  }
}
</script>

<style lang="stylus" scoped>
.modal-study-confirm
  &__inner
    &__title
      position sticky
      top 0
      padding 15px 0 0
      color var(--color-modal-study-confirm-title__text)
    &__body
      margin 10px 0 70px
      padding 0 20px
      &__text
        white-space pre-line
        &:first-child
          margin-top 25px
        &:not(:last-child)
          margin-bottom 15px
      &__alart
        overflow-y auto
        margin-bottom 10px
        max-height 60px
        &__text
          display flex
          justify-content center
          color var(--color-modal-study-confirm-alert__text)
    &__footer
      position absolute
      display flex
      justify-content space-around
      bottom 0
      padding 5px 0 15px
      width 100%
      &__button
        width 100%
        margin 0 30px
</style>
